var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.hideSearchPanel),expression:"!$route.meta.hideSearchPanel"}],attrs:{"justify":"end","no-gutters":""}},[_vm._t("default",null,null,{ textFilter: _vm.textFilter, formatFilter: _vm.formatFilter, orderArea: _vm.orderArea })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }